import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FilePending"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.025 6.975L14.775 1.725C14.6413 1.57686 14.4495 1.49465 14.25 1.5H6.75C5.92157 1.5 5.25 2.17158 5.25 3V11.0149H6.75V3.00002H12.75V7.50002C12.75 8.32845 13.4216 9.00002 14.25 9.00002H18.75V21H14.9582V22.5H18.75C19.5784 22.5 20.25 21.8284 20.25 21V7.5C20.2554 7.30052 20.1731 7.10869 20.025 6.975ZM14.25 3.29999L18.45 7.49999H14.25V3.29999ZM9.375 22.5C6.47551 22.5 4.125 20.1495 4.125 17.25C4.125 14.3505 6.47551 12 9.375 12C12.2745 12 14.625 14.3505 14.625 17.25C14.625 20.1495 12.2745 22.5 9.375 22.5ZM10.4518 19.3865L8.81004 17.6957V14.4069H9.92187V17.0483L11.3385 18.5646L10.4518 19.3865ZM5.50262 17.25C5.50262 15.179 7.09681 13.3265 9.37498 13.3265C11.6532 13.3265 13.2929 15.179 13.2929 17.25C13.2929 19.3211 11.6532 21.2316 9.37498 21.2316C7.09681 21.2316 5.50262 19.3211 5.50262 17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FilePending.vue"]]);
